import Vue from 'vue';
import { getToken } from './utils/tokenManager';

function setAuthorizationHeader(request, next) {
  const token = getToken();

  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }

  next();
}

function handle401(router) {
  return function(request, next) {
    next(async response => {
      if (!response.ok && response.status === 401) {
        router.push({ name: 'logout' }).catch(() => {});
      }

      return response;
    });
  };
}

export default function registerHttpInterceptors({ router }) {
  Vue.http.interceptors.push(setAuthorizationHeader);
  Vue.http.interceptors.push(handle401(router));
}
